export const GRAPH_REFRESH_INTERVAL_MS = 30000;
